import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import DownloadIcon from '@mui/icons-material/Download';
import { styled } from '@mui/material/styles';
import type { Document } from '@contentful/rich-text-types';

import { RichTextBlock } from 'components/ContentfulContent/RichText/RichTextBlock';
import { filterPageBreakMacro } from 'lib/legal-docs/helper';

interface LegalDocType {
  document?: Document;
  pdfLink?: string;
}

const Wrapper = styled('div')`
  padding: ${({ theme }) => theme.spacing(3)} 0;
`;

const PdfLinkBox = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const PdfLink = styled(Link)`
  text-decoration: none;
`;

export const LegalDoc = ({ document, pdfLink }: LegalDocType) => {
  const filteredDoc = filterPageBreakMacro(document);

  return (
    <Wrapper>
      {pdfLink && (
        <Container sx={{ marginBottom: 4 }}>
          <PdfLinkBox>
            <PdfLink
              href={pdfLink}
              aria-label="PDF herunterladen"
              target="_blank"
            >
              <DownloadIcon fontSize="inherit" />
              &nbsp;PDF herunterladen
            </PdfLink>
          </PdfLinkBox>
        </Container>
      )}

      <RichTextBlock document={filteredDoc} />
    </Wrapper>
  );
};
